import React, { useEffect, useState } from "react";
import { useDragContext } from "../../context/DragContext";
import TradingViewChart from "../charts/RealtimeTrdingChart";
import { useDispatch, useSelector } from "react-redux";
import { setChartSymbol } from "../../store/Slices/watchList";

const PanelDropZone = ({ id }) => {
    const { isDragging, endDrag } = useDragContext();
    const chartSymbols = useSelector((state) => state.watchlist.chartSymbols);
    const dispatch = useDispatch();

    const handleDrop = (e) => {
        e.preventDefault();
        const symbolId = e.dataTransfer.getData('symbolId');
        // setDropzoneData(symbolId);
        dispatch(setChartSymbol([id, symbolId]))
        endDrag();
    };


    return (
        <div
            onDragOver={e => e.preventDefault()}
            onDrop={handleDrop}
            className="h-full w-full relative"
        >
            {isDragging && (
                <div className={`absolute h-full w-full top-0 left-0 z-50 `} />
            )}
            {chartSymbols?.[id] && <TradingViewChart symbolId={chartSymbols?.[id]} sx={{ position: 'relative' }} />}
            {/* {dropzoneData} */}
        </div>
    );
};

export default PanelDropZone;
